import { getDriverData, getDriverDataById, type DriverListParams } from '@dc-trans/data-layer';
import { useQuery } from '@tanstack/react-query';

export const driverKeys = {
  all: ['driver'] as const,
  list: (params?: DriverListParams) => [...driverKeys.all, 'list', params] as const,
  detail: (id: string) => [...driverKeys.all, 'detail', id] as const,
};

export const useDriverList = (params?: DriverListParams) => {
  return useQuery({
    queryKey: driverKeys.list(params),
    queryFn: () => getDriverData(params),
  });
};

export const useDriverDetail = (id: string) => {
  return useQuery({
    queryKey: driverKeys.detail(id),
    queryFn: () => getDriverDataById(id),
    enabled: !!id,
  });
};
